import { word } from "@/modules/core/utils/i18n"
import { cn } from "@/modules/lib/utils"
import { TemplateSessionView } from "@/modules/template/components/sidebarView/templateSessionView"
import { Text } from "@/components/ui/baseUi/text"
import { EmptyView } from "@/modules/ui/components/emptyView"
import SessionEmpty from "@images/empty/session_empty.svg"
import { Button } from "@/components/ui/baseUi/button"
import { useSidebar } from "@/modules/sidebar/hooks/useSidebar"
import type { TemplateSessionEntity } from "@/modules/template/entities/templateElementEntity"
import { useTemplateElement } from "@/modules/template/hooks/useTemplate"

type TemplateSessionViewWrapperProps = {
  templateId: string
  session?: TemplateSessionEntity
  className?: string
} & React.ComponentProps<"div">

export function TemplateSessionViewWrapper({
  templateId,
  session,
  className,
  ...props
}: TemplateSessionViewWrapperProps) {
  const { hideSidebar } = useSidebar()
  const { data: templateElement } = useTemplateElement(templateId)
  const sessionElement = "session" in templateElement ? templateElement.session : session

  if (!sessionElement) {
    return (
      <div className={cn("flex w-full grow flex-col gap-4 px-6 pt-18 pb-6", className)} {...props}>
        <Text fontStyle="TL">{word("template.title.text.sessionTemplate")}</Text>
        <EmptyView
          image={{ src: SessionEmpty }}
          title={word("session.empty.title.noExercise")}
          description={word("session.empty.description.noExercise")}
          flexGrow={false}
          className="bg-surface-foreground p-6"
          button={
            <Button
              variant="primary"
              onClick={() => {
                hideSidebar()
              }}
            >
              {word("global.button.wait")}
            </Button>
          }
          paddingType="In_table"
        />
      </div>
    )
  }

  return <TemplateSessionView session={sessionElement} className={className} {...props} />
}
